import { Component, inject } from '@angular/core';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { getPhonePrefixOptions } from '@shared/utils';
import { DYNAMIC_PHONE_DIRECTIVE_CONFIG } from '../../shared/constants/dynamic-phone-directive-config.constants';
import { RegisterProbateFormService } from './register-probate-form.service';
import { UserSearchStateService } from '../../shared/services/user-search-state.service';
import { ReactiveFormsModule } from '@angular/forms';
import { AutocompleteComponent } from '@shared/components/autocomplete';
import { ButtonComponent } from '@shared/components/button';
import { FormMessageComponent } from '@shared/components/forms';
import {
  PhoneNumberMaskDirective,
  DynamicPhoneValidationDirective,
} from '@shared/directives';
import {
  HandleAutocompleteOptionClickDirective,
  HandleUserSearchDirective,
} from '../../shared/directives';
import { CloseApplicationModalDirective } from '../../shared/directives/close-modal.directive';
import { ClerkCreateEstateFacadeService } from './clerk-create-estate-facade.service';
import { HandleClerkCreateEstateSubmitDirective } from './directives/handle-clerk-create-estate-submit.directive';
import { CREATE_APPLICATION_PROBATE_ERROR_MESSAGES } from './constants';
import { CcsInputComponent, CcsSelectComponent } from '@shared/components';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-clerk-create-probate-form',
  templateUrl: 'clerk-create-probate-form.component.html',
  imports: [
    ReactiveFormsModule,
    AutocompleteComponent,
    FormMessageComponent,
    ButtonComponent,
    HandleUserSearchDirective,
    PhoneNumberMaskDirective,
    DynamicPhoneValidationDirective,
    CloseApplicationModalDirective,
    HandleClerkCreateEstateSubmitDirective,
    HandleAutocompleteOptionClickDirective,
    CcsInputComponent,
    CcsSelectComponent,
    MatSlideToggleModule,
  ],
  providers: [RegisterProbateFormService, ClerkCreateEstateFacadeService],
})
export class ClerkCreateProbateFormComponent {
  private readonly _registerApplicationFormService = inject(
    RegisterProbateFormService,
  );

  private readonly _userSearchStateService = inject(UserSearchStateService);

  protected readonly form = this._registerApplicationFormService.registerForm;
  protected readonly ERROR_MESSAGES = CREATE_APPLICATION_PROBATE_ERROR_MESSAGES;
  protected readonly isLoading = this._userSearchStateService.isLoading;

  protected isSending = this._registerApplicationFormService.isLoading;

  protected formattedUsersByName =
    this._userSearchStateService.formattedSearchedUsersByName;
  protected formattedUsersByEmail =
    this._userSearchStateService.formattedSearchedUsersByEmail;

  protected readonly phonePrefixOptions = getPhonePrefixOptions();

  protected readonly dynamicPhoneDirectiveConfig =
    DYNAMIC_PHONE_DIRECTIVE_CONFIG;

  protected get isPhonePrefixUS() {
    return this.form.controls.prefixPhone.value === DEFAULT_USA_PHONE_PREFIX;
  }

  protected readonly isFirm = this._registerApplicationFormService.isFirm;
}
